import { useState, useEffect } from "react";
import "./counter.css";

export const Counter = ({ endDate, isStart }) => {
  const [RemainedTime, setRemainedTime] = useState(0);
  const [isCountStart, setIsCountStart] = useState(false);
  const [days, setdays] = useState(0);
  const [hours, sethours] = useState(0);
  const [mins, setmins] = useState(0);
  const [secs, setsecs] = useState(0);

  useEffect(() => {
    let now = new Date().getTime() / 1000;
    if (endDate === 0) {
      return;
    }
    if (endDate > 0) {
      let remainTime = Number.parseInt(endDate - now);
      setRemainedTime(remainTime);
      setIsCountStart(true);
    }
  }, [endDate]);

  // countdown timer
  useEffect(() => {
    if (!isCountStart) return;
    if (RemainedTime < 0) {
      return isStart(true);
    }
    const intervalId = setInterval(() => {
      setRemainedTime(RemainedTime - 1);
      setsecs(Math.floor(RemainedTime % 60));
      setmins(Math.floor((RemainedTime / 60) % 60));
      sethours(Math.floor((RemainedTime / 60 / 60) % 24));
      setdays(Math.floor(RemainedTime / 60 / 60 / 24));
    }, 1000);

    return () => clearInterval(intervalId);
  }, [RemainedTime, isCountStart, isStart]);

  return (
    <div className="row big-countdown">
      <div className="col-6 col-sm-3">
        <span className="number-days">{isCountStart ? days : 0}</span>
        <span className="txt-countdown">days </span>
      </div>
      <div className="col-6 col-sm-3">
        <span className="number-hours">{isCountStart ? hours : 0}</span>
        <span className="txt-countdown">hours </span>
      </div>
      <div className="col-6 col-sm-3">
        <span className="number-minutes">{isCountStart ? mins : 0}</span>
        <span className="txt-countdown">minutes </span>
      </div>
      <div className="col-6 col-sm-3">
        <span className="number-seconds">{isCountStart ? secs : 0}</span>
        <span className="txt-countdown">seconds </span>
      </div>
    </div>
  );
};
